import React from "react";
import { Box, FormControlLabel, Typography, Checkbox, Divider, CircularProgress, Button, RadioGroup, FormControl, Modal } from "@mui/material";
import ProfilePropComponent from "../../../components/ui/ProfilePropComponent";
import BoxContainer from "../../../components/ui/BoxContainer";
import { CheckBox } from "@mui/icons-material";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { useEffect } from "react";
import Api from "../../../api/Api";
import { Urls } from "../../../api/Urls";
import { useState } from "react";
import leftArrowIcon from "../../../imgs/imgV2/leftArrowBlack.svg";
import arrowRightIcon from "../../../imgs/imgV2/arrowRightBlavk.svg";
import ButtonSquare from "../../../components/ui/ButtonSquare";
import { modalStyle2 } from "../../../theme/ModalStyle";
import DetailsProfileInterim from "./DetailsProfileInterim";
import InterimComponent from "../../../components/ui/InterimComponent";
function PropositionMission({ id }) {
  const { user } = useAuthContext();
  const [candidatures, setCandidatures] = useState([]);
  const access_token = user?.access_token;
  const [loading, setLoading] = useState(true);
  const [motifs, setMotifs] = useState([]);
  const [postulerIDS, setPostulerIDS] = useState([]);

  const [change, setChange] = useState(false);
  const [matching, setMatching] = useState([]);
  const [role, setRole] = useState();

  const [exp, setExp] = useState("");

  const [checkedState, setCheckedState] = useState({
    checked1: false,
    checked2: false,
    checked3: false,
  });
  const [data, setData] = useState({});
  useEffect(() => {
    Api.get(Urls.GET_INTERIMS_BY_OFFER + id + "/proposed-interims", {
      headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
      params: {
        perPage: 8,
        ...(exp ? { doesntHaveExperience: 1 } : null),
        ...(matching ? { matchingLevels: matching } : null),
      },
    })
      .then((res) => {
        console.log(res, "liste des candidatures");
        setCandidatures(res?.data?.interims);
        setLoading(false);
        setData(res?.data);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [change, exp, matching]);
  useEffect(() => {
    Api.get(Urls.GET_REFUSAL_REASONS_ENTREPRISE, {
      headers: { "content-type": "appication/json", authorization: `Bearer ${user?.access_token}` },
    })
      .then((res) => {
        console.log(res);
        setMotifs(res?.data?.enterprise_refusal_reasons);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  //handle Pagination
  const handlePagination = (link) => {
    console.log("getting data");
    Api.get(`${link}`, {
      headers: { "Content-type": "application/json", authorization: `Bearer ${access_token}` },
    })
      .then((res) => {
        console.log("RESULTAT MATCHED offres DATA", res?.data);
        console.log("RESPONES GHERBI", res);
        setData(res?.data);
        setCandidatures(res.data?.interims);
      })
      .catch((err) => {
        console.log(err);
        setCandidatures([]);
      });
  };
  return (
    <Box display="flex" gap="24px">
      <Box flex={1}>
        <BoxContainer>
          <Box display="flex" flexDirection="column" gap="24px">
            <Box>
              <Typography fontSize="20px" lineHeight="32px" fontWeight="700">
                🔍 Filtres
              </Typography>
            </Box>
            <Box display="flex" flexDirection="column" gap="18px">
              <Typography fontSize="14px" fontWeight="500">
                Matching
              </Typography>
              <Box>
                <Box width="100%">
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={(e) => {
                          setCheckedState({ ...checkedState, checked1: e.target.checked });
                          e.target.checked === true ? setMatching((matching) => matching.concat(["perfect"])) : setMatching(matching.filter((matching) => matching !== "perfect"));
                        }}
                        checked={checkedState.checked1}
                      />
                    }
                    label="🥇 Parfait"
                  />
                </Box>
                <Box width="100%">
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={(e) => {
                          setCheckedState({ ...checkedState, checked2: e.target.checked });
                          e.target.checked === true ? setMatching((matching) => matching.concat(["suitable"])) : setMatching(matching.filter((matching) => matching !== "suitable"));
                        }}
                        checked={checkedState.checked2}
                      />
                    }
                    label="👌 Satisfaisant"
                  />
                </Box>
                <Box width="100%">
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={(e) => {
                          setCheckedState({ ...checkedState, checked3: e.target.checked });
                          exp !== "none" ? setExp("none") : setExp("");
                        }}
                        checked={checkedState.checked3}
                      />
                    }
                    label="Je n’ai pas d’experience"
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </BoxContainer>
      </Box>
      <Box flex={3}>
        {loading ? (
          <Box display="fex" justifyContent="center">
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Box>
              {candidatures?.map((candidature) => (
                <InterimComponent interim={candidature} id={id} postulerIDS={postulerIDS} setPostulerIDS={setPostulerIDS} />
              ))}
            </Box>
            {candidatures?.length > 0 && <Divider sx={{ marginTop: "24px", marginBottom: "24px" }} />}
            {candidatures?.length === 0 && <Typography textAlign="center">Aucun profile proposé</Typography>}
            {candidatures?.length > 0 && (
              <Box marginBottom="24px" display="flex" alignItems="center" gap="20px" justifyContent="space-between">
                <Box flex={1}>
                  {data?.links?.prev && (
                    <>
                      <Button
                        sx={{ display: { xs: "none", sm: "none", lg: "inherit", md: "inherit" } }}
                        onClick={() => {
                          handlePagination(data?.links?.prev);
                          window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                          });
                        }}
                        variant="mj_secondary_md"
                      >
                        <img style={{ marginRight: "8px" }} src={leftArrowIcon} alt="arrow-left" /> Précédent
                      </Button>
                      <Button
                        sx={{ display: { xs: "inherit", sm: "inherit", lg: "none", md: "none" } }}
                        onClick={() => {
                          handlePagination(data?.links?.prev);

                          window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                          });
                        }}
                        variant="mj_secondary_md"
                      >
                        <img src={leftArrowIcon} alt="arrow-left" />
                      </Button>
                    </>
                  )}
                </Box>
                <Box sx={{ flex: { xs: 8, sm: 8, md: 6, lg: 6 } }} display="flex" gap="10px" justifyContent="center">
                  {data?.meta?.links?.map((link, index) => (
                    <>
                      {index !== 0 && index !== data?.meta?.last_page + 1 && (
                        <ButtonSquare
                          onClick={() => {
                            handlePagination(link.url);
                            window.scrollTo({
                              top: 0,
                              behavior: "smooth",
                            });
                          }}
                          action={link?.active ? "number-active" : "number"}
                          number={link.label}
                        />
                      )}
                    </>
                  ))}
                </Box>
                <Box flex={1}>
                  {data?.links?.next && (
                    <>
                      <Button
                        sx={{ display: { xs: "none", sm: "none", lg: "inherit", md: "inherit" } }}
                        onClick={() => {
                          handlePagination(data?.links?.next);
                          window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                          });
                        }}
                        variant="mj_secondary_md"
                      >
                        Suivant <img style={{ marginLeft: "8px" }} src={arrowRightIcon} alt="arrow-right" />
                      </Button>
                      <Button
                        sx={{ display: { xs: "inherit", sm: "inherit", lg: "none", md: "none" } }}
                        onClick={() => {
                          handlePagination(data?.links?.next);
                          window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                          });
                        }}
                        variant="mj_secondary_md"
                      >
                        <img src={arrowRightIcon} alt="arrow-right" />
                      </Button>
                    </>
                  )}
                </Box>
              </Box>
            )}
          </>
        )}
      </Box>
    </Box>
  );
}

export default PropositionMission;
